<template>
  <div class="home">
    <headerNav></headerNav>
    <div class="banner">
      <el-carousel :interval="5000" arrow="always">
        <el-carousel-item v-for="item in bannerList" :key="item">
          <img :src="item.img" alt="" @click="toWaiLian(item.url)" />
        </el-carousel-item>
      </el-carousel>
      <img
        src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/leftMeng.png"
        alt=""
        class="bannerLeft"
      />
      <img
        src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/rightMeng.png"
        alt=""
        class="bannerRight"
      />
    </div>
    <!-- 学校概况,新闻动态 -->
    <div class="smallMian">
      <div class="xue">
        <div class="xueTop">
          <div class="xueTitle">学校概况</div>
          <div class="more" @click="skip('学校概况')">
            MORE
            <img
              src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/jiantou.png"
              alt=""
            />
          </div>
        </div>
        <img
          src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/xian.png"
          alt=""
          class="xian"
        />

        <div class="xueBtm">
          <div class="xueLeft">
            <el-carousel :interval="5000" arrow="always" height="278px">
              <el-carousel-item v-for="item in xxglList" :key="item">
                <img :src="item" alt="" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="xueRight">{{ xxglInfo }}</div>
        </div>
      </div>
      <div class="news">
        <div class="xueTop">
          <div class="xueTitle">新闻动态</div>
          <div class="more" @click="skip('新闻动态')">
            MORE
            <img
              src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/jiantou.png"
              alt=""
            />
          </div>
        </div>
        <img
          src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/xian2.png"
          alt=""
          class="xian"
        />

        <div class="newsBtm">
          <div
            class="newsItem"
            v-for="(item, index) in xwdtList"
            :key="index"
            @click="toDetail(item.id)"
          >
            <div class="newsLeft">
              <div class="ri">{{ item.DAY }}</div>
              <div class="nianyue">{{ item.yearMonth }}</div>
            </div>
            <div class="newsRight">
              {{ item.info }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 管理团队 -->
    <div class="bigMain">
      <div class="glTop">
        <div class="glTitle">管理团队</div>
        <div class="glMore">
          <!-- MORE <span> > </span> -->
        </div>
      </div>
      <img
        src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/glLine.png"
        alt=""
        class="glLine"
      />
      <div class="xzBox">
        <div class="glMain">
          <img :src="gltdImg" alt="" class="glImg" />
          <div class="glInfo">
            {{ gltdInfo }}

            <p @click="skip('管理团队,8')">MORE</p>
          </div>
          <div class="glMore" @click="skip('管理团队,8')"></div>
        </div>

        <div class="glMain">
          <img :src="gltdImg1" alt="" class="glImg" />
          <div class="glInfo">
            {{ gltdInfo1 }}
            <p @click="skip('管理团队,10')">MORE</p>
          </div>
          <div class="glMore" @click="skip('管理团队,10')" data-id="10"></div>
        </div>
        <div class="glMain">
          <img :src="gltdImg2" alt="" class="glImg" />
          <div class="glInfo">
            {{ gltdInfo2 }}
            <p @click="skip('管理团队,13')" data-id="13">MORE</p>
          </div>
          <br />
          <div class="glMore" @click="skip('管理团队,13')" data-id="13"></div>
        </div>
        <div class="glMain">
          <img :src="gltdImg3" alt="" class="glImg" />
          <div class="glInfo">
            {{ gltdInfo3 }}
            <p @click="skip('管理团队,14')" data-id="14">MORE</p>
          </div>
          <br />
          <div class="glMore" @click="skip('管理团队,14')" data-id="14"></div>
        </div>
      </div>

      <div class="jiaoxueLjian">
        办学理念及培养目标：
        <br />
        <br />
        <img
          src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/glLine.png"
          alt=""
          class="glLine"
        />
        <p>
          学校践行“双遵循”办学理念，即“遵循教育规律办教育，遵循学生的成长规律办教育”，全力培养具有家国情怀和世界胸襟的创新人才。
        </p>
      </div>
    </div>
    <!-- 教师风采 -->
    <div class="smallMian1" v-if="jiaoList.length > 0">
      <div class="xueTop" @click="skip('教师代表')">
        <div class="xueTitle">名师工作室成员</div>
        <div class="more">
          MORE
          <img
            src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/jiantou.png"
            alt=""
          />
        </div>
      </div>
      <img
        src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/xueline.png"
        alt=""
        class="xian"
      />

      <div class="jiaoBox">
        <div
          class="jiaoItem"
          v-for="(item, index) in jiaoList"
          :key="index"
          @click="toDetail2(item.id)"
        >
          <div class="jiaoMain">
            <img :src="item.img" alt="" class="jiaoLeft" />
            <div class="jiaoRight">
              <div>{{ item.name }}</div>
              <p>{{ item.remark2 }}</p>
              <!-- <div class="ql-snow">
                <div class="ql-editor" v-html="item.rich_text"></div>
              </div> -->
            </div>
          </div>
          <div class="jsMore">MORE</div>
        </div>
      </div>
    </div>

    <!-- 服务中心 -->
    <div class="bigMain bigMain1">
      <div class="serviceTitle">服务中心</div>
      <div class="serveiceMain">
        <div
          class="serveiceItem"
          v-for="(item, index) in serviceList"
          :key="index"
          @click="skip(item.name)"
        >
          <div class="serviceName">{{ item.name }}</div>
          <img :src="item.img" alt="" class="serveiceImg" />
        </div>
      </div>
    </div>
    <!-- 宣传专区,加入我们 -->
    <div class="smallMian">
      <div class="xue1">
        <div class="xueTop" @click="skip('宣传专区')">
          <div class="xueTitle">宣传专区</div>
          <div class="more">
            MORE
            <img
              src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/jiantou.png"
              alt=""
            />
          </div>
        </div>
        <img
          src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/xian.png"
          alt=""
          class="xian"
        />

        <div class="xuanBtm">
          <div class="xuanLeft">
            <el-carousel :interval="5000" arrow="always" height="356px">
              <el-carousel-item v-for="item in xuanList" :key="item">
                <!-- <img :src="item" alt="" /> -->
                <video :src="item" controls></video>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="news1">
        <div class="xueTop" @click="skip('加入我们')">
          <div class="xueTitle">加入我们</div>
          <div class="more">
            MORE
            <img
              src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/jiantou.png"
              alt=""
            />
          </div>
        </div>
        <img
          src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/xian2.png"
          alt=""
          class="xian"
        />

        <div class="newsBtm1">
          <div
            class="newsItem1"
            v-for="(item, index) in addUsList"
            :key="index"
            @click="toDetail1(item.id)"
          >
            <div class="jiaruLeft">
              <div class="jiaruTitle">{{ item.title }}</div>
              <div class="jiaruTime">{{ item.createTime }}</div>
            </div>
            <div class="jiaruRight">
              <img :src="item.img" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="margin-top: 30px"></div>
    <Footer></Footer>
  </div>
</template>

<script>
import headerNav from "../components/headerNav.vue";
import Footer from "../components/footer.vue";
const axios = require("axios");
export default {
  name: "home",
  components: { headerNav, Footer },
  data() {
    return {
      bannerList: [],
      // 学校概况
      xxglList: [],
      xxglInfo: "",
      // 新闻动态
      xwdtList: [],
      // 管理团队
      gltdImg: "",
      gltdInfo: "",
      // 教师风采
      jiaoList: [],
      // 服务中心
      serviceList: [],
      // 宣传专区
      xuanList: [],
      // 加入我们
      addUsList: [],
    };
  },
  created() {
    // axios
    //   .post("http://103.46.128.45:7001/hxz/v1/orderQuery", {
    //     Order: "2021053110013100000",
    //     CardNo: "0841543223",
    //     CardMode: 0,
    //   })
    //   .then((response) => {
    //     alert("3333333");
    //     console.log(response.data); // 处理响应数据
    //   })
    //   .catch((error) => {
    //     alert("444");
    //     console.error(error); // 处理错误情况
    //   });
    // axios
    //   .get("https://syb-test.allinpay.com/apiweb/h5unionpay/unionorder", {
    //   },
    //   {
    //     Headers:{
    //       'Content-type':'application/json'
    //     }
    //   })
    //   .then((response) => {
    //     alert("3333333");
    //     console.log(response.data); // 处理响应数据
    //   })
    //   .catch((error) => {
    //     // alert("444");
    //     alert(error); // 处理错误情况
    //   });
  },
  mounted() {
    this.api.homeApi({}).then((res) => {
      console.log(res.data);
      this.xxglList = res.data[0].imgs;
      this.xxglInfo = res.data[0].info;
      this.xwdtList = res.data[1];
      this.gltdImg = res.data[2][0].img;
      this.gltdInfo = res.data[2][0].info;
      this.gltdImg1 = res.data[2][1].img;
      this.gltdInfo1 = res.data[2][1].info;
      this.gltdImg2 = res.data[2][2].img;
      this.gltdInfo2 = res.data[2][2].info;
      this.gltdImg3 = res.data[2][3].img;
      this.gltdInfo3 = res.data[2][3].info;
      this.jiaoList = res.data[3];
      this.serviceList = res.data[4];
      this.xuanList = res.data[5];
      this.addUsList = res.data[6];
    });
    this.api.banner({}).then((res) => {
      this.bannerList = res.data;
    });
  },
  methods: {
    toWaiLian(e) {
      if (e != "") {
        window.open(e);
      }
    },
    toDetail(e) {
      this.$router.push({ path: "/xwxq", query: { id: e } });
    },
    toDetail1(e) {
      this.$router.push({ path: "/zpjzDetail", query: { id: e } });
    },
    toDetail2(e) {
      this.$router.push({ path: "/jsDetail", query: { id: e } });
    },
    skip(e) {
      sessionStorage.setItem("navTitle", e);
      console.log(e);
      if (e == "学校概况") {
        this.$router.push("/xxjj");
      } else if (e == "新闻动态") {
        this.$router.push("/xxyw");
      } else if (e == "管理团队,8") {
        // this.$router.push("/tdgl?id1=8");
        this.$router.push({ path: "/tdgl", query: { id1: "8" } });
      } else if (e == "管理团队,10") {
        // this.$router.push("/tdgl?id1=10");

        this.$router.push({ path: "/tdgl", query: { id1: "10" } });
      } else if (e == "管理团队,13") {
        // this.$router.push("/tdgl?id1=10");

        this.$router.push({ path: "/tdgl", query: { id1: "13" } });
      } else if (e == "管理团队,14") {
        // this.$router.push("/tdgl?id1=10");

        this.$router.push({ path: "/tdgl", query: { id1: "14" } });
      } else if (e == "教师代表") {
        this.$router.push("/jsdb");
      } else if (e == "国际交流") {
        this.$router.push("/jlhf");
      } else if (e == "课程介绍") {
        this.$router.push("/czkc");
      } else if (e == "图书馆") {
        this.$router.push("/xyhj");
      } else if (e == "信息中心") {
        this.$router.push("/zpjz");
      } else if (e == "指导中心") {
        this.$router.push("/zzjs");
      } else if (e == "艺体中心") {
        this.$router.push("/xszp");
      } else if (e == "宣传专区") {
        this.$router.push("/spzq");
      } else if (e == "加入我们") {
        this.$router.push("/zpjz");
      }
    },
  },
};
</script>
<style scoped>
.home {
  max-width: 1920px;
}

.banner {
  width: 100%;
  height: 600px;
  position: relative;
}
.banner img {
  width: 100%;
  height: 600px;
}
.banner /deep/.el-carousel__button {
  display: block;
  opacity: 0.48;
  width: 34px;
  height: 9px;
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  transition: 0.3s;
  border-radius: 13px;
  background: rgb(172, 171, 171);
}
.banner /deep/ .el-carousel__container {
  height: 600px;
}

.banner /deep/ .is-active .el-carousel__button {
  opacity: 0.48;
  width: 34px;
  height: 9px;
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  transition: 0.3s;
  border-radius: 13px;
  background-color: rgb(255, 255, 255);
}

.banner /deep/.el-carousel__indicators--horizontal {
  bottom: 70px;
  left: 50%;
  transform: translateX(-50%);
}
.bannerLeft {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 99;
  width: 1899px;
  height: 270px !important;
}

.bannerRight {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 99;
  width: 1145px;
  height: 262px !important;
}
.el-carousel__item {
}

.smallMian {
  width: 1200px;
  margin: 0px auto;
  margin-top: 60px;
  display: flex;
  justify-content: space-between;
}

.xue {
  width: 645px;
}
.xue1 {
  width: 710px;
}
.xueTop {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.xueTitle {
  color: rgb(152, 33, 35);
  font-family: 思源黑体;
  font-size: 28px;
  font-weight: 700;
  line-height: 41px;
  letter-spacing: 0%;
  text-align: left;
}

.more {
  color: rgb(90, 83, 83);
  font-family: SimHei;
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 2px;
  text-align: right;
  cursor: pointer;
}
.more img {
  width: 32px;
  height: 32px;
  position: relative;
  top: 8px;
}
.xian {
  width: 100%;
  height: 12px;
  margin: 20px 0;
}
.news {
  width: 463px;
}
.news1 {
  width: 400px;
}

.xueBtm {
  width: 100%;
  height: 280px;
  display: flex;
  justify-content: space-between;
}

.xueLeft,
.xueLeft img {
  width: 362px;
  height: 278px;
  border-radius: 20px;
}
.xuanBtm {
  width: 100%;
  height: 356px;
}
.xuanLeft,
.xuanLeft video {
  width: 710px;
  height: 356px;
  border-radius: 30px;
}

.xuanLeft /deep/.el-carousel__button {
  display: block;
  opacity: 0.48;
  width: 17px;
  height: 17px;
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  transition: 0.3s;
  border-radius: 50%;
  background: rgb(196, 196, 196);
}

.xuanLeft /deep/ .is-active .el-carousel__button {
  opacity: 0.48;
  width: 17px;
  height: 17px;
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  transition: 0.3s;
  border-radius: 50%;
  background: rgb(252, 247, 248);
}
.xueLeft /deep/.el-carousel__button {
  display: block;
  opacity: 0.48;
  width: 17px;
  height: 17px;
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  transition: 0.3s;
  border-radius: 50%;
  background: rgb(196, 196, 196);
}

.xueLeft /deep/ .is-active .el-carousel__button {
  opacity: 0.48;
  width: 17px;
  height: 17px;
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  transition: 0.3s;
  border-radius: 50%;
  background: rgb(252, 247, 248);
}

.xueRight {
  width: 253px;
  height: 240px;
  color: rgb(97, 92, 92);
  font-family: 思源黑体;
  font-size: 16px;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: 0%;
  text-align: left;
}

.newsBtm {
  width: 463px;
  height: 278px;
  background: rgb(247, 247, 247);
}
.newsBtm1 {
  width: 406px;
  height: 356px;
  background: rgb(247, 247, 247);
}

.newsItem1 {
  width: 85%;
  padding: 20px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.08);
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  cursor: pointer;
}
.jiaruLeft {
  width: 159px;
}

.jiaruTitle {
  color: rgba(0, 0, 0, 0.8);
  font-family: 思源黑体;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
}

.jiaruTime {
  color: rgba(0, 0, 0, 0.3);
  font-family: 思源黑体;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
  margin-top: 10px;
}

.jiaruRight,
.jiaruRight img {
  width: 93px;
  height: 73px;
  overflow: hidden;
}
.newsItem {
  width: 100%;
  padding: 15px 0;
  display: flex;
  justify-content: space-around;
  cursor: pointer;
}
.newsLeft {
  width: 66px;
  height: 66px;
  border-radius: 50%;
  background: rgb(241, 231, 219);
}
.ri {
  color: rgb(152, 33, 35);
  font-family: 思源黑体;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0%;
  text-align: center;
  margin-top: 5px;
}

.nianyue {
  color: rgb(152, 33, 35);
  font-family: 思源黑体;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0%;
  text-align: center;
}
.newsRight {
  width: 338px;
  color: rgb(97, 92, 92);
  font-family: 思源黑体;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0%;
  text-align: left;
}

.bigMain {
  margin: 0px auto;
  margin-top: 60px;
  width: 100%;
  height: 1000px;
  background-image: url("https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/gltd.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.bigMain1 {
  margin: 0px auto;
  margin-top: 40px;
  width: 100%;
  height: 580px;
  background-image: url("https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/gltd.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.jiaoxueLjian {
  width: 1200px;
  margin: 20px auto;
  font-family: 思源黑体;
  font-size: 28px;
  font-weight: 700;
  color: rgb(152, 33, 35);
}
.jiaoxueLjian p {
  text-indent: 2em;
  color: black;
  line-height: 40px;
  margin-top: 30px;
  font-size: 26px;
  font-weight: normal;
}
.glTop {
  width: 1200px;
  margin: 0 auto;
  padding-top: 40px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}
.glTitle {
  color: rgb(152, 33, 35);
  font-family: 思源黑体;
  font-size: 28px;
  font-weight: 700;
  line-height: 41px;
  letter-spacing: 0%;
  text-align: left;
}

.glMore {
  color: rgb(90, 83, 83);
  font-family: SimHei;
  font-size: 18px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 2px;
  text-align: right;
  cursor: pointer;
}
.glMore span {
  width: 17px;
  height: 9px;
  font-weight: bold;
  color: rgb(152, 33, 35);
}

.glLine {
  display: block;
  margin: 0 auto;
  margin-bottom: 20px;
}
.xzBox {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  margin: 20px auto;
  flex-wrap: wrap;
}

.glMain {
  width: 570px;
  margin-bottom: 40px;
  display: flex;
  justify-content: space-between;
  /* background: orange; */
}
.glImg {
  width: 159px;
  height: 217px;
  border-radius: 20px;
  display: block;
}
.glInfo {
  width: 450px;
  height: 200px;
  color: rgb(97, 92, 92);
  font-family: 思源黑体;
  font-size: 15px;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: 0%;
  text-align: left;
  margin-left: 10px;
  /* background: yellowgreen; */
}
.glInfo p {
  cursor: pointer;
}
.smallMian1 {
  width: 1200px;
  margin: 0px auto;
  margin-top: 60px;
}
.jiaoTitle {
  color: rgb(152, 33, 35);
  font-family: 思源黑体;
  font-size: 28px;
  font-weight: 700;
  line-height: 41px;
  letter-spacing: 0%;
  text-align: left;
}
.jiaoline {
  display: block;
  margin: 0 auto;
  margin-top: 17px;
  margin-bottom: 40px;
}
.jiaoBox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.jiaoItem {
  width: 374px;
  border-top: 8px solid rgb(152, 33, 35);
  margin-right: 38px;
  margin-bottom: 50px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
}
.jiaoItem:nth-child(3n) {
  margin-right: 0 !important;
}

.jiaoMain {
  width: 95%;
  padding-top: 22px;
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.jsMore {
  width: 56px;
  height: 21px;
  border-radius: 3px;
  background: rgb(152, 33, 35);
  margin: 10px auto;
  margin-bottom: 20px;
  color: rgb(255, 255, 255);
  font-family: SimHei;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 2px;
  text-align: center;
  cursor: pointer;
}

.jiaoLeft {
  width: 88px;
  height: 119.7px;
  display: block;
}

.jiaoRight {
  width: 240px;
  height: 235px;
  color: rgb(97, 92, 92);
  font-family: 思源黑体;
  font-size: 14px;
  font-weight: 500;
  line-height: 25px;
  letter-spacing: 0%;
  text-align: left;
  overflow-y: hidden;
}

.serviceTitle {
  color: rgb(152, 33, 35);
  font-family: 思源黑体;
  font-size: 28px;
  font-weight: 700;
  line-height: 41px;
  letter-spacing: 0%;
  text-align: center;
  padding-top: 50px;
  margin-bottom: 40px;
}

.serveiceMain {
  width: 1200px;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
}
.serveiceItem {
  width: 327px;
  height: 120px;
  margin-right: 109px;
  box-sizing: border-box;
  border: 1px solid rgb(255, 255, 255);
  border-radius: 12px;
  box-shadow: 0px 4px 4px 0px rgba(179, 178, 178, 0.25);
  background: rgba(255, 255, 255, 0.71);
  margin-bottom: 38px;
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  color: rgb(97, 92, 92);
}

.serveiceItem:hover {
  width: 327px;
  height: 120px;
  margin-right: 109px;
  box-sizing: border-box;
  border: 1px solid rgb(255, 255, 255);
  border-radius: 12px;
  box-shadow: 0px 4px 4px 0px rgba(179, 178, 178, 0.25);
  margin-bottom: 38px;
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  background: rgba(152, 33, 35, 0.35);
  color: rgb(246, 245, 248);
}
.serveiceItem:nth-child(3n) {
  margin-right: 0;
}
.serviceName {
  font-family: 思源黑体;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 20%;
  text-align: left;
  margin-top: 45px;
}

.serveiceImg {
  width: 52px;
  height: 52px;
  display: block;
  margin-top: 34px;
}

div /deep/.ql-editor {
  box-sizing: border-box;
  counter-reset: list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8
    list-9;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  padding: 0;
  -o-tab-size: 4;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
}

@media screen and (max-width: 1440px) {
  div /deep/.ql-editor p {
    font-size: 13px !important;
  }
}

@media screen and (max-width: 450px) {
  .home {
    max-width: 450px;
    overflow: hidden;
  }
  .banner {
    width: 100%;
    height: 120px;
    position: relative;
  }
  .banner img {
    width: 100%;
    height: 120px;
  }
  .banner /deep/ .el-carousel__container {
    height: 120px;
  }
  .banner /deep/.el-carousel__button {
    display: block;
    opacity: 0.48;
    width: 34px;
    height: 9px;
    border: none;
    outline: 0;
    padding: 0;
    margin: 0;
    cursor: pointer;
    transition: 0.3s;
    border-radius: 13px;
    background: rgb(172, 171, 171);
  }

  .banner /deep/ .is-active .el-carousel__button {
    opacity: 0.48;
    width: 34px;
    height: 9px;
    border: none;
    outline: 0;
    padding: 0;
    margin: 0;
    cursor: pointer;
    transition: 0.3s;
    border-radius: 13px;
    background-color: rgb(255, 255, 255);
  }

  div/deep/.el-carousel__indicators--horizontal {
    bottom: 70px;
    left: 50%;
    transform: translateX(-50%);
    display: none;
  }
  .bannerLeft {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 99;
    width: 371px;
    height: 62px !important;
  }

  .bannerRight {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 99;
    width: 224px;
    height: 57px !important;
  }
  .el-carousel__item {
  }

  .smallMian {
    width: 350px;
    margin: 0px auto;
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
  }

  .xue {
    width: 170px;
    height: 170px;
  }
  .xue1 {
    width: 150px;
  }
  .xueTop {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .xueTitle {
    color: rgb(152, 33, 35);
    font-family: 思源黑体;
    font-size: 13px;
    font-weight: 700;
    line-height: 41px;
    letter-spacing: 0%;
    text-align: left;
  }

  .more {
    color: rgb(90, 83, 83);
    font-family: SimHei;
    font-size: 12px;
    font-weight: 400;
    line-height: 40px;
    letter-spacing: 2px;
    text-align: right;
    cursor: pointer;
  }
  .more img {
    width: 20px;
    height: 20px;
    position: relative;
    top: 8px;
  }
  .xian {
    width: 100%;
    height: 6px;
    margin: 8px 0;
  }
  .news {
    width: 170px;
    height: 170px;
  }
  .news1 {
    width: 180px;
  }

  .xueBtm {
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: space-between;
  }

  .xueLeft,
  .xueLeft img {
    width: 100px;
    height: 70px;
    border-radius: 10px;
  }

  .xueLeft /deep/.el-carousel__button {
    height: 70px;
  }
  .xuanBtm {
    width: 160px;
    height: 130px;
  }
  .xuanLeft,
  .xuanLeft video {
    width: 150px;
    height: 150px;
    border-radius: 0px;
  }
  /deep/.el-carousel__arrow,
  .el-carousel__arrow--left {
    display: none;
  }
  .xueRight {
    width: 70px;
    height: 100px;
    color: rgb(97, 92, 92);
    font-family: 思源黑体;
    font-size: 6px;
    font-weight: 500;
    line-height: 8px;
    letter-spacing: 0%;
    text-align: left;
    margin-left: 5px;
  }

  .newsBtm {
    width: 160px;
    height: 110px;
    background: rgb(247, 247, 247);
  }
  .newsBtm1 {
    width: 160px;
    height: 190px;
    background: rgb(247, 247, 247);
  }

  .newsItem1 {
    width: 85%;
    padding: 5px;
    border-bottom: 2px solid rgba(0, 0, 0, 0.08);
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    cursor: pointer;
  }
  .jiaruLeft {
    width: 89px;
  }

  .jiaruTitle {
    color: rgba(0, 0, 0, 0.8);
    font-family: 思源黑体;
    font-size: 10px;
    font-weight: 400;
    line-height: 12px;
    letter-spacing: 0px;
    text-align: left;
  }

  .jiaruTime {
    color: rgba(0, 0, 0, 0.3);
    font-family: 思源黑体;
    font-size: 8px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: left;
    margin-top: 5px;
  }

  .jiaruRight,
  .jiaruRight img {
    width: 43px;
    height: 33px;
    overflow: hidden;
  }
  .newsItem {
    width: 100%;
    padding: 5px 0;
    display: flex;
    justify-content: space-around;
    cursor: pointer;
  }
  .newsLeft {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    margin-left: 5px;
    background: rgb(241, 231, 219);
  }
  .ri {
    color: rgb(152, 33, 35);
    font-family: 思源黑体;
    font-size: 8px;
    font-weight: 500;
    letter-spacing: 0%;
    text-align: center;
    margin-top: 3px;
  }

  .nianyue {
    color: rgb(152, 33, 35);
    font-family: 思源黑体;
    font-size: 6px;
    font-weight: normal;
    letter-spacing: 0%;
    text-align: center;
  }
  .newsRight {
    width: 160px;
    color: rgb(97, 92, 92);
    font-family: 思源黑体;
    font-size: 8px;
    font-weight: 500;
    line-height: 12px;
    letter-spacing: 0%;
    text-align: left;
    margin-left: 5px;
  }

  .bigMain {
    margin: 0px auto;
    margin-top: 40px;
    width: 100%;
    height: 780px;
    background-image: url("https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/gltd.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .bigMain1 {
    margin: 0px auto;
    margin-top: 40px;
    width: 100%;
    height: 220px;
    background-image: url("https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/gltd.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .glTop {
    width: 370px;
    margin: 0 auto;
    padding-top: 10px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
  }
  .glTitle {
    color: rgb(152, 33, 35);
    font-family: 思源黑体;
    font-size: 13px;
    font-weight: 700;
    line-height: 41px;
    letter-spacing: 0%;
    text-align: left;
  }

  .glMore {
    color: rgb(90, 83, 83);
    font-family: SimHei;
    font-size: 12px;
    font-weight: 400;
    line-height: 40px;
    letter-spacing: 2px;
    text-align: right;
    cursor: pointer;
  }
  .glMore span {
    width: 17px;
    height: 9px;
    font-weight: bold;
    color: rgb(152, 33, 35);
  }

  .glLine {
    display: block;
    margin: 0 auto;
    margin-bottom: 20px;
    width: 100%;
  }

  .xzBox {
    width: 350px;
    display: flex;
    justify-content: space-between;
    margin: 20px auto;
    flex-wrap: wrap;
  }
  .glMain {
    width: 375px;
    height: 127px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .glImg {
    width: 90px;
    height: 110px;
    border-radius: 15px;
    display: block;
  }

  /* .glText {
    width: 250px;
    height: 130px;
    color: rgb(97, 92, 92);
    font-family: 思源黑体;
    font-size: 6px;
    font-weight: 500;
    line-height: 15px;
    letter-spacing: 0%;
    text-align: left;
    overflow: hidden;
    margin-right: 5px;
    margin-top: -15px;
  } */

  .glInfo {
    width: 180px;
    height: 200px;
    color: rgb(97, 92, 92);
    font-family: 思源黑体;
    font-size: 6px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0%;
    text-align: left;
    /* background: yellowgreen; */
  }

  .jiaoxueLjian {
    width: 300px;
    margin: 10px auto;
    color: rgb(152, 33, 35);
    font-family: 思源黑体;
    font-size: 13px;
    font-weight: 700;
  }

  .jiaoxueLjian p {
    width: 300px;
    margin: 10px auto;
    color: black;
    font-size: 11px;
    text-indent: 2em;
    font-weight: normal;
    line-height: 20px;
  }
  .smallMian1 {
    width: 375px;
    margin: 0px auto;
    margin-top: 30px;
  }
  .jiaoTitle {
    color: rgb(152, 33, 35);
    font-family: 思源黑体;
    font-size: 13px;
    font-weight: 700;
    line-height: 41px;
    letter-spacing: 0%;
    text-align: left;
  }
  .jiaoline {
    display: block;
    margin: 0 auto;
    margin-top: 17px;
    margin-bottom: 40px;
  }
  .jiaoBox {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  .jiaoItem {
    width: 120px;
    border-top: 8px solid rgb(152, 33, 35);
    margin-right: 5px;
    margin-bottom: 20px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
  }
  .jiaoItem:nth-child(3n) {
    margin-right: 0 !important;
  }

  .jiaoMain {
    width: 95%;
    padding-top: 12px;
    padding-bottom: 10px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
  }
  .jsMore {
    width: 36px;
    height: 20px;
    border-radius: 3px;
    background: rgb(152, 33, 35);
    margin: 10px auto;
    margin-bottom: 10px;
    color: rgb(255, 255, 255);
    font-family: SimHei;
    font-size: 8px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 2px;
    text-align: center;
    cursor: pointer;
  }

  .jiaoLeft {
    width: 50px;
    height: 70px;
    display: block;
  }

  .jiaoRight {
    width: 70px;
    height: 100px;
    color: rgb(97, 92, 92);
    font-family: 思源黑体;
    font-size: 12px;
    font-weight: 500;
    line-height: 25px;
    letter-spacing: 0%;
    text-align: left;
    overflow-y: hidden;
    margin-left: 5px;
  }
  .jiaoRight /deep/.ql-editor p {
    font-size: 8px !important;
  }

  .serviceTitle {
    color: rgb(152, 33, 35);
    font-family: 思源黑体;
    font-size: 15px;
    font-weight: 700;
    line-height: 41px;
    letter-spacing: 0%;
    text-align: center;
    padding-top: 15px;
    margin-bottom: 10px;
  }

  .serveiceMain {
    width: 375px;
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
  }
  .serveiceItem {
    width: 120px;
    height: 50px;
    margin-right: 5px;
    box-sizing: border-box;
    border: 1px solid rgb(255, 255, 255);
    border-radius: 12px;
    box-shadow: 0px 4px 4px 0px rgba(179, 178, 178, 0.25);
    background: rgba(255, 255, 255, 0.71);
    margin-bottom: 15px;
    cursor: pointer;
    display: flex;
    justify-content: space-around;
    color: rgb(97, 92, 92);
  }

  .serveiceItem:hover {
    width: 120px;
    height: 50px;
    margin-right: 5px;
    box-sizing: border-box;
    border: 1px solid rgb(255, 255, 255);
    border-radius: 12px;
    box-shadow: 0px 4px 4px 0px rgba(179, 178, 178, 0.25);
    margin-bottom: 15px;
    cursor: pointer;
    display: flex;
    justify-content: space-around;
    background: rgba(152, 33, 35, 0.35);
    color: rgb(246, 245, 248);
  }
  .serveiceItem:nth-child(3n) {
    margin-right: 0;
  }
  .serviceName {
    font-family: 思源黑体;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 20%;
    text-align: left;
    margin-top: 18px;
  }

  .serveiceImg {
    width: 20px;
    height: 20px;
    display: block;
    margin-top: 15px;
  }

  div /deep/.ql-editor {
    box-sizing: border-box;
    counter-reset: list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7
      list-8 list-9;
    line-height: 1.42;
    height: 100%;
    outline: none;
    overflow-y: auto;
    padding: 0;
    -o-tab-size: 4;
    tab-size: 4;
    -moz-tab-size: 4;
    text-align: left;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  /deep/.glText .ql-editor p {
    font-size: 10px !important;
  }
}
</style>
